'use strict';

define(
	'TrackSelectorWindowDir',[],function () {
		function TrackSelectorWindowDir() {
			return {
				restrict: 'E',
				templateUrl: 'js/modules/BetSlipWindow/templates/track-selector-window.html',
				controller: 'TrackSelectorWindowCtrl',
				scope: true
			};
		}
		return TrackSelectorWindowDir;
	}
);

